import component from './PlanCards.vue'
export default component
